import { styled } from '@zenbusiness/zui/styles';

export const WrapperStyle = () => ({
  width: '100%'
});

export const WrapperStyled = styled('div')(WrapperStyle);
